import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import { RequestError } from "../Entity/RequestError";
import { Brand } from "../Entity/Brand";
import { AppThunk } from "../../app/store";
import { getBrandBySlugRep } from "../Repository/BrandRepository";

interface BrandState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  error: RequestError | null,
  brand: Brand|null,
}

const BrandInitialState: BrandState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  brand: null,
  error: null,
}

function getBrandStartRequest(state: BrandState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.brand = null;
}

function getBrandFailed(state: BrandState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function getBrandSuccess(state: BrandState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.brand = action.payload;
  state.error = null;
}

const brandSlice = createSlice({
    name: 'brands',
    initialState: BrandInitialState,
    reducers: {
      BrandStartRequest: getBrandStartRequest,
      BrandSuccess: getBrandSuccess,
      BrandFailed: getBrandFailed,
    }
  }
)

export const {
  BrandStartRequest,
  BrandSuccess,
  BrandFailed,
} = brandSlice.actions;

export default brandSlice.reducer;

export const getBrandBySlug = (locale: string,brandName: string): AppThunk => async dispatch => {

  try {
    const newsApiResponse = await getBrandBySlugRep(locale, brandName);
    dispatch(BrandSuccess(newsApiResponse));
  } catch (err) {
    dispatch(BrandFailed(err));
  }
}
